import React from 'react';
import PropTypes from 'prop-types';
import Ticket from './Ticket';

const Tickets = ({onChange, tickets}) => {
  const extrasTickets = tickets.map((ticket, index) => (
    <Ticket index={index} inputChange={onChange} key={index} ticket={ticket} />
  ));

  return (
    <div className="service-list">
      {extrasTickets}
    </div>
  );
};

Tickets.PropTypes = {
  onChange:PropTypes.func.isRequired,
  tickets:PropTypes.array.isRequired,
};

export default Tickets;
